module.exports = {"id":"s5-q5","text":"How do you access your email?","multiselect":true,"next":"s6-q1","options":[{"id":"s5-q5-a1","text":"On your phone using an email app","capability":1,"access":1},{"id":"s5-q5-a2","text":"On your phone using a web browser","capability":1,"access":2},{"id":"s5-q5-a3","text":"On your tablet or computer using an email app","capability":1,"access":3},{"id":"s5-q5-a4","text":"On your tablet or computer using a web browser","capability":2,"access":3},{"id":"s5-q5-a5","text":"On a public computer","capability":1,"access":-2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s5-q5.json
// module id = 912
// module chunks = 41